import cn from 'classnames';
import { FormattedMessage, useIntl } from 'react-intl';

import gladCat from '@/shared/assets/images/cats/glad.png';
import { useMedia } from '@/shared/hooks';
import { Button, WidgetCard } from '@/shared/ui';

import styles from './PurchasePrompt.module.scss';

type PurchasePromptProps = {
  title: string;
  isOwner: boolean;
  onOpenShop: () => void;
  className?: string;
  testID?: string;
};

export const PurchasePrompt = (props: PurchasePromptProps) => {
  const { title, isOwner, onOpenShop, className, testID } = props;

  const { formatMessage } = useIntl();
  const { isMobile } = useMedia();

  return (
    <WidgetCard
      data-testid={testID}
      data-component="purchase-promotion-prompt"
      className={cn(styles.container, className)}
    >
      <header className={cn(styles.header, isMobile ? 'h2m' : 'h4')}>
        {title}
      </header>

      <main className={styles.main}>
        <img
          src={gladCat}
          alt={formatMessage({
            id: 'imgAltText.gladCat',
            defaultMessage: 'Glad cat',
          })}
          className={styles.gladCatImg}
        />

        <span className={cn(styles.message, isMobile ? 'p2m' : 'p2')}>
          <FormattedMessage
            id="purchasePrompt.subscribeToUnlock"
            defaultMessage="Subscribe to unlock report ordering"
          />
        </span>

        {isOwner && (
          <Button onClick={onOpenShop} size={isMobile ? 'medium' : 'large'}>
            <FormattedMessage
              id="purchasePrompt.choosePlan"
              defaultMessage="Choose a plan"
            />
          </Button>
        )}
      </main>
    </WidgetCard>
  );
};
